import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["max", "current", "text"];
import React from "react";
import PropTypes from 'prop-types';
import styled from 'styled-components';

var Charcounter = function Charcounter(_ref) {
  var _ref$max = _ref.max,
      max = _ref$max === void 0 ? 255 : _ref$max,
      _ref$current = _ref.current,
      current = _ref$current === void 0 ? 0 : _ref$current,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? 'char. max' : _ref$text,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("figcaption", props, "".concat(current, "/").concat(max, " ").concat(text));
};

Charcounter.propTypes = {
  text: PropTypes.string,
  max: PropTypes.number,
  current: PropTypes.number
};
var StyledCharcounter = styled(Charcounter).withConfig({
  displayName: "CharCounter__StyledCharcounter",
  componentId: "sc-1ggjc8l-0"
})(["color:", ";font-size:14px;"], function (props) {
  return props.current < props.max ? '#757575' : '#c9012f';
});
export default StyledCharcounter;